<tp-modal [dialogTitle]="title" [isBusy]="isSubmitting$ | async">
  @if (price$ | async; as price) {
    <p class="modal-content-wrapper">
      Are you sure you would like to {{ data.action }} '{{ data.cluster.id }}'?
    </p>

    @if (price.running.thousandthCentsPerHour != 0) {
      @if (data.action == "pause") {
        <p class="modal-content-wrapper">
          Doing so will prevent you from reading or writing data until it's resumed.
          We will continue to maintain your data during pause until you choose to resume or destroy the cluster.
        </p>
        <div class="modal-content-wrapper info-block">
          <i class="fa-solid fa-circle-info"></i>
          <p>
            Your running cluster costs <strong>{{ runningPriceString(price) }}</strong>. When paused, it will cost <strong>{{ pausedPriceString(price) }}</strong>
          </p>
        </div>
      } @else {
        <div class="modal-content-wrapper info-block">
          <i class="fa-solid fa-circle-info"></i>
          <p>
            Your paused cluster costs <strong>{{ pausedPriceString(price) }}</strong>. When running, it will cost <strong>{{ runningPriceString(price) }}</strong>
          </p>
        </div>
      }
    }
  } @else {
    <tp-spinner/>
  }
  <tp-form-actions
    [submitText]="submitText" [submitButtonStyle]="submitButtonStyle"
    [buttonIdPrefix]="buttonIdPrefix" [submitDisabled]="!(price$ | async)"
    [isSubmitting]="isSubmitting$ | async" (submitClick)="confirm()" [cancellable]="true" (cancel)="close()"
  />
</tp-modal>
